import React from "react";
import { useTable } from "../../Components/useTable";

const GiftListRank = () => {
  const type = "Gift Rank";
  const headCells = [
    { id: "code", numeric: false, label: "Code" },
    { id: "name", numeric: false, label: "User Name" },
    { id: "totalDiamond", numeric: false, label: "Diamond" },
    { id: "pictureUrl", numeric: false, label: "Picture" },
    { id: "usercountry", numeric: false, label: "Country" },
    { id: "userbirthday", numeric: false, label: "BirthDay" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default GiftListRank;
